import React from "react"

import { LoginOverlayView } from "./LoginOverlayView"

export interface LoginOverlayModel {
  loginAsEmployee?: () => void
  loginAsVisitor?: () => void
  onClose: () => void
}

export interface LoginOverlayProps extends LoginOverlayModel {}

export const LoginOverlay = React.memo((props: LoginOverlayProps) => (
  <LoginOverlayView {...props} />
))
